export default {
	gridList: [],
	useYnList: [], // PWAYN 콤보박스 리스트
	msgIdList: [], // 메세지id 콤보박스 리스트
	searchParams: SEARCH_PARAMS(),
	groups: GROUPS()
};
function GROUPS() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 1
	};
}
function SEARCH_PARAMS() {
	return {
		opCd: '',
		useYn: 'Y'
	};
}

export { SEARCH_PARAMS, GROUPS };
